import React from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';

// Using posed in order to easily animate expand/collapse of the condition description
const PosedContent = posed.div({
  expanded: { height: 'auto' },
  collapsed: { height: 0 }
});

class Expando extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.defaultOpen
    };
  }

  render() {
    return (
      <div className={`expando ${this.props.className}${this.state.open ? 'open' : ''}`}>
        <div
          className="expando__header"
          onClick={this.handleHeaderClick.bind(this)}
        >
          <div className="expando__header__left">
            { this.props.header ?
              this.props.header
              :
              <div
                className="expando__title"
                onClick={this.handleTitleClick.bind(this)}
              >
                <h4>{ this.props.title }</h4>
              </div>
            }
          </div>

          <div className="expando__header__right">
            <div
              className={`expando__toggle ${this.state.open ? 'rotated' : ''}`}
              onClick={this.handleToggleClick.bind(this)}
            >
              <button><i className="icon icon--bottom"/></button>
            </div>
          </div>
        </div>

        <PosedContent
          className="expando__content-wrapper"
          pose={this.state.open ? 'expanded' : 'collapsed'}
        >
          <div className="expando__content">{this.props.content}</div>
        </PosedContent>
      </div>
    );
  }

  handleHeaderClick() {
    this.toggleContent();
  }

  handleTitleClick(event) {
    event.preventDefault();

    this.toggleContent();
  }

  handleToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.toggleContent();
  }

  toggleContent() {
    this.setState({ open: !this.state.open });
  }
}

Expando.defaultProps = {
  className: '',
  title: '',
  defaultOpen: false
};

Expando.propTypes = {
  className: PropTypes.string,
  defaultOpen: PropTypes.bool,
  header: PropTypes.node,
  title: PropTypes.string,
  content: PropTypes.node.isRequired
};

export default Expando;
